module.exports = __webpack_public_path__ + "img/calendar.2fdda4f5.svg";